export function programmeReducer(
  state = {
    loading: false,
    result: [],
    programmeResult: [],
    error: null
  },
  action
) {
  switch (action.type) {
    case "FETCH_PROGRAMME_BEGIN": {
      return { ...state, loading: true };
    }
    case "FETCH_PROGRAMME_REJECTED": {
      return { ...state, loading: false, error: action.payload };
    }
    case "FETCH_PROGRAMME_FULFILLED": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case "FETCH_PROGRAMMES_BEGIN": {
      return { ...state, loading: true };
    }
    case "FETCH_PROGRAMMES_REJECTED": {
      return { ...state, loading: false, error: action.payload };
    }
    case "FETCH_PROGRAMMES_FULFILLED": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}

export function fortnoxProgramReducer(
  state = {
    loading: false,
    result: [],
    error: null
  },
  action
) {
  switch (action.type) {
    case "FETCH_FORTNOX_PROGRAMS_BEGIN": {
      return { ...state, loading: true };
    }
    case "FETCH_FORTNOX_PROGRAMS_REJECTED": {
      return { ...state, loading: false, error: action.payload };
    }
    case "FETCH_FORTNOX_PROGRAMS_FULFILLED": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
